import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

const BasicInfoBody = (props) => {
    const sections = props.sections;
  return (
    <div className={styles.detail}>
      <div className={styles.row}>
        <InputControl
          label="Name"
          placeholder="Enter your full name eg. Aashu"
          value={props.information[sections.basicInfo].detail.name}
          // value={values.name}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.basicInfo]: {...prev[sections.basicInfo], 
                    detail: {...prev[sections.basicInfo].detail, name: event.target.value}
                } 
            }))
          }
        />
        <InputControl
          label="Title"
          value={props.information[sections.basicInfo].detail.title}
          // value={values.title}
          placeholder="Enter your title eg. Frontend developer"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.basicInfo]: {...prev[sections.basicInfo], 
                    detail: {...prev[sections.basicInfo].detail, title: event.target.value}
                } 
            }))
          }
        />
      </div>
      <div className={styles.row}>
        <InputControl
          label="Linkedin Link"
          value={props.information[sections.basicInfo].detail.linkedin}
          // value={values.linkedin}
          placeholder="Enter your linkedin profile link"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.basicInfo]: {...prev[sections.basicInfo], 
                    detail: {...prev[sections.basicInfo].detail, linkedin: event.target.value}
                } 
            }))
          }
        />
        <InputControl
          label="Github Link"
          value={props.information[sections.basicInfo].detail.github}
          // value={values.github}
          placeholder="Enter your github profile link"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.basicInfo]: {...prev[sections.basicInfo], 
                    detail: {...prev[sections.basicInfo].detail, github: event.target.value}
                } 
            }))
          }
        />
      </div>
      <div className={styles.row}>
        <InputControl
          label="Email"
          value={props.information[sections.basicInfo].detail.email}
          // value={values.email}
          placeholder="Enter your email"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.basicInfo]: {...prev[sections.basicInfo], 
                    detail: {...prev[sections.basicInfo].detail, email: event.target.value}
                } 
            }))
          }
        />
        <InputControl
          label="Enter phone"
          value={props.information[sections.basicInfo].detail.phone}
          // value={values.phone}
          placeholder="Enter your phone number"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.basicInfo]: {...prev[sections.basicInfo], 
                    detail: {...prev[sections.basicInfo].detail, phone: event.target.value}
                } 
            }))
          }
        />
      </div>
    </div>
  )
}

export default BasicInfoBody